import {IShipmentStore} from '@/models/StoreModels';
import {ISpecification} from "@/models/specifications/SpecificationHelpers/ISpecification";

import {StoreShipmentPhoneIsCorrect} from "@/models/specifications/StoreShipmentHelpers/StoreShipmentPhoneIsCorrect";
import {StoreShipmentNoteIsCorrect} from "@/models/specifications/StoreShipmentHelpers/StoreShipmentNoteIsCorrect";
import {StoreShipmentHubIdIsCorrect} from "@/models/specifications/StoreShipmentHelpers/StoreShipmentHubIdIsCorrect";
import {StoreShipmentCellSizeIsCorrect} from "@/models/specifications/StoreShipmentHelpers/StoreShipmentCellSizeIsCorrect";

export class StoreCrossTownDataIsReadyToSend implements ISpecification<IShipmentStore> {
  private phoneIsCorrect = new StoreShipmentPhoneIsCorrect();
  private cellSizeIsCorrect = new StoreShipmentCellSizeIsCorrect();
  private noteIsCorrect = new StoreShipmentNoteIsCorrect();
  private hubIdIsCorrect = new StoreShipmentHubIdIsCorrect();

  public IsSatisfiedBy(candidate: IShipmentStore): boolean {
    return this.phoneIsCorrect.IsSatisfiedBy(candidate) &&
      this.cellSizeIsCorrect.IsSatisfiedBy(candidate) &&
      this.hubIdIsCorrect.IsSatisfiedBy(candidate) &&
      this.noteIsCorrect.IsSatisfiedBy(candidate);
  }

}



